<template>
    <picture>
        <template v-if="brand == 'abarth'">
            <source type="image/webp" srcset="/img/logos/borderless/abarth.webp, /img/logos/borderless/abarth@2x.webp 2x'">
            <img :class="classes" src="/img/logos/borderless/abarth.jpg, /img/logos/borderless/abarth@2x.jpg 2x" alt="Abarth">
        </template>
        <template v-else>
            <img :class="classes" :src="'/img/logos/borderless/' + brand + '.svg'" :alt="manufacturer">
        </template>
    </picture>
</template>

<script>
import GetManufacturerFromBrand from '../../api/GetManufacturerFromBrand'
    export default {
        props: {
            brand: {
                default: '',
                required: true,
            },
            logoClass: {
                default: '',
            },
        },
        computed: {
            classes() {
                if (this.logoClass.length > 0) {
                    return this.logoClass;
                }
                return 'img-responsive';
            },
            manufacturer() {
                return GetManufacturerFromBrand(this.brand);
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/Logos/BorderlessLogo.vue